:
<template>
    <div>
        <div class="flex">
            <table v-if="itemsCurrent.length" class="table" :class="tableDark">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Precio</th>
                        <th v-if="enabled" scope="col">
                            <div class="flex justify-center">
                                <span>🧤</span>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in itemsCurrent" :key="index">
                        <th scope="w-1/12">{{ index }}</th>
                        <td class="w-5/12">
                            <span>
                                {{ item.name }}
                            </span>
                        </td>
                        <td class="w-4/12">
                            <span>
                                {{ item.priceOffer | money }}
                            </span>
                        </td>

                        <td v-if="enabled" class="w-2/12">
                            <div class="flex justify-center">
                                <button
                                    class="btn w-3 h-3 flex items-center justify-center"
                                    :disabled="index === 0"
                                    @click="moveOrder(index, index - 1)"
                                >
                                    ⬆
                                </button>

                                <button
                                    class="btn w-3 h-3 flex items-center justify-center"
                                    :disabled="index >= itemsCurrent.length - 1"
                                    @click="moveOrder(index, index + 1)"
                                >
                                    ⬇
                                </button>
                                <button
                                    class="btn btn-danger w-3 h-3 flex items-center justify-center"
                                    @click="deleteService(index)"
                                >
                                    🗑️
                                </button>
                                <button
                                    class="btn w-3 h-3 flex items-center justify-center"
                                    @click="editService(index)"
                                >
                                    🖊
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else class="w-10/12 mx-auto py-3">
                <span class="text-lg">
                    Nuestro sistema no ha encotrado servicios registrados 0️⃣.
                </span>
            </div>
        </div>

        <div v-if="enabled" class="my-4 w-full flex justify-center">
            <custom-tooltip border>
                <button
                    class="w-full btn border-2 border-gary-600 rounded-lg h-24 flex justify-center items-center"
                    @click="openNewService"
                >
                    <h2 class="text-lg">&nbsp;➕&nbsp;</h2>
                </button>
                <template #tooltip> Agregar servicios</template>
            </custom-tooltip>
        </div>

        <div>
            <app-dialog v-model="isOpenModalSelectService" size="sm">
                <div>
                    <span class="text-lg">
                        {{
                            isEditingService
                                ? "Edita servicio"
                                : "Nuevo servicio"
                        }}
                    </span>
                    <div class="flex flex-col min-w-48">
                        <div class="w-full mt-4">
                            <span> Nombre </span>
                            <custom-input
                                id="name_"
                                v-model="filterTmp.name"
                                autocomplete="off"
                                type="text"
                                name="name"
                                placeholder="Nombre del servicio"
                            />
                        </div>
                        <div class="w-full mt-4">
                            <span> Precio </span>
                            <custom-input
                                id="start_"
                                v-model="priceOffer"
                                autocomplete="off"
                                step="10000"
                                type="text"
                                name="start"
                                @input="formatPriceOffer"
                            />
                        </div>
                    </div>

                    <div v-if="showDuplicate" class="mx-3 mt-2">
                        <span class="text-lg text-danger mt-4">
                            Ya tienes un servicio con el nombre
                            {{ filterTmp.name }}
                        </span>
                    </div>
                    <div class="flex justify-center mt-4">
                        <app-button
                            :disabled="isInvalidCurrentService"
                            class="mt-3 mb-5 w-3/4 mx-auto"
                            border
                            gradient
                            @click="pushNewService"
                        >
                            <span class="text-lg"> Guardar ✔️ </span>
                        </app-button>
                    </div>
                </div>
            </app-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "ServicesInMerchantManage",
    components: { AppDialog, CustomInput },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: Array,
            default: () => [
                {
                    name: "alt",
                    priceOffer: 5000
                }
            ],
            required: true
        },
        enabled: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        showDuplicate: false,
        priceOffer: "$10.000",
        isEditingService: false,
        isOpenModalSelectService: false,
        filterTmp: {
            name: "",
            priceOffer: 20000
        }
    }),
    computed: {
        ...mapGetters("control", ["tableDark"]),
        isInvalidCurrentService() {
            return (
                this.filterTmp.name === "" ||
                this.filterTmp.priceOffer < 0 ||
                this.showDuplicate
            );
        }
    },
    watch: {},
    methods: {
        moveOrder(fromIndex, toIndex) {
            let arrAux = [...this.itemsCurrent];
            const aux = arrAux[fromIndex];
            arrAux.splice(fromIndex, 1);
            arrAux.splice(toIndex, 0, aux);
            this.$emit("change", arrAux);
        },
        editService(fromIndex) {
            this.isEditingService = true;
            let arrAux = [...this.itemsCurrent];
            this.filterTmp = arrAux[fromIndex];
            this.isOpenModalSelectService = true;
        },
        deleteService(fromIndex) {
            let filtersResult = [...this.itemsCurrent];
            filtersResult.splice(fromIndex, 1);
            this.$emit("change", filtersResult);
        },
        openNewService() {
            this.isEditingService = false;
            this.filterTmp = {
                name: "",
                priceOffer: 10000
            };
            this.isOpenModalSelectService = true;
        },
        pushNewService() {
            const filtersAux = [...this.itemsCurrent];
            if (this.isEditingService) {
                const itemAux = filtersAux.findIndex(
                    (item) => item.key === this.filterTmp.key
                );
                filtersAux[itemAux] = this.filterTmp;
                this.isEditingService = false;
            } else {
                filtersAux.push(this.filterTmp);
            }
            this.$emit("change", filtersAux);
            this.isOpenModalSelectService = false;
        },
        formatPriceOffer() {
            this.filterTmp.priceOffer = parseInt(
                this.priceOffer.replace(/[^0-9]+/g, "")
            );
            this.priceOffer = this.$options.filters.currency(
                this.filterTmp.priceOffer
            );
        },
        formatName() {
            if (this.filterTmp.name === "Nombre del servicio") {
                this.filterTmp.name = "";
            }
        }
    }
};
</script>
